import crypto from 'providers/crypto';

export const SHOULD_NOT_AUTH = 1;
export const SHOULD_AUTH = 2;
export const NO_DIFFERENT = 3;
export const APP_ENV_PRODUCTION = 'production';
export const APP_ENV_DEVELOPMENT = 'development';

export const TIMER_SECONDS = 'timerSeconds';
export const TIMER_MINUTES = 'timerMinutes';